import React, { useState, createContext, useContext } from 'react';


const AppConfigContext = createContext(null);

export function useAppConfig(){
    const config = useContext(AppConfigContext);
    if(!config) throw new Error('useAppConfig must be used within AppConfigProvider');
    return config;
}

export const AppConfigProvider = ({ children,  agentLdap, routingProfile, contactsList,isAppOnline,routingValue, appendingValue}) => {
    const [wsConn, setWsConn] = useState(null);
    const [userSession, setUserSession] = useState({
        content:'',
        contactId:''
    });
    const updateuserSession = (value) => {
        setUserSession(value);
    }
    const [incommingMessageEvent, setIncommingMessageEvent] = useState({
        contactId:'',
        message:''
    });
    const updateWsConnection = (value) => {
        setWsConn(value);
    }
    const [selectContact, setSelectContact] = useState(null)
    const updateSelectContact = (value) => {
        setSelectContact(value)
    }

    const [selectInitialContact, setSelectInitialContact] = useState(null)
    const updateSelectInitialContact = (value) => {
        setSelectInitialContact(value)
    }
    
    const [endContactId, setEndContactId] = useState(null);
    const updateEndContactId = (value) => {
        setEndContactId(value)
    }

    const [ cannedMsgSet, setCannedMsgSet] = useState({});
    const updateCannedMsgSet=(value)=>{
        setCannedMsgSet(value)
    }

    const [activeContactList, setActiveContactList] = useState(contactsList)
    const updateContactList = (value) => {
        setActiveContactList(value);
    }

    const [passTranscript, setPassTranscript] = useState(null);
    const updateSetPassTranscript = (value) => {
        setPassTranscript(value);
    }

    const [loading, setLoading] = useState(false);
    const updateSetLoading = (value) => {
        setLoading(value);
    }
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const updateSetShowFeedbackModal = (value) => {
        setShowFeedbackModal(value);
    }
    const [storeFeedback, setStoreFeedback] = useState([]);
    const updateSetStoreFeedback = (value) => {
        setStoreFeedback(value);
    }
    const providerValue = {
        selectContact,
        updateSelectContact,
        endContactId,
        updateEndContactId,
        updateCannedMsgSet,
        cannedMsgSet,
        agentLdap,
        routingProfile, wsConn, updateWsConnection , contactsList, activeContactList, updateContactList, isAppOnline,
        selectInitialContact, updateSelectInitialContact, routingValue, passTranscript, updateSetPassTranscript,
        updateuserSession,
        userSession,loading,
        updateSetLoading,
        showFeedbackModal,
        updateSetShowFeedbackModal,
        storeFeedback,
        updateSetStoreFeedback,
        appendingValue
    };

    return (
        <AppConfigContext.Provider value={providerValue}>
            {children}
        </AppConfigContext.Provider>
    )
}